/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { REQUIRED_FIELD_ERROR, FIELD_INVALID, REQUIRED_FIELD_ERROR_FEM } from '@masfront/common-b2c'
import { string, object } from 'yup'

const contactSchema = (isOffline: boolean) =>
  object().shape({
    language: string().label('idioma').required(REQUIRED_FIELD_ERROR),
    email: string().email(FIELD_INVALID).label('email de contacto').required(REQUIRED_FIELD_ERROR),
    province: isOffline
      ? string().nullable().label('provincia').required(REQUIRED_FIELD_ERROR_FEM)
      : string().nullable().label('provincia'),
  })

export default contactSchema
